// The migration adds stable codes. Title fallback keeps existing directories usable during rollout.
export const financingCode = (type) => {
  if (type?.code) return type.code;
  switch (type?.title?.trim()) {
    case 'Ипотека': return 'mortgage';
    case 'Рассрочка': return 'installment';
    case 'Полная оплата': return 'full_payment';
    case 'Не определились': return 'undecided';
    default: return '';
  }
};
